var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUparrow = function SvgUparrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c-.34.009-.547.113-.694.247L.417 7.595C-.065 7.942-.141 8.728.25 9.22c.39.493 1.12.52 1.556.124l7.083-5.847V24.87C8.889 25.494 9.386 26 10 26a1.12 1.12 0 0 0 1.111-1.13V3.496l7.083 5.847c.439.448 1.21.32 1.621-.152.317-.365.217-1.334-.232-1.597L10.695.247C10.465.055 10.293-.003 10 0Z",
    fill: "#000"
  })));
};
export default SvgUparrow;